<template>
  <div class="py-3 px-4">
    <v-row class="my-0">
      <v-col>
        <div class="d-flex justify-start align-start">
          <v-btn
            @click="toggleFiltersPanel"
            class="ml-auto mr-2"
            text
            depressed
            :class="[showFilter ? 'grey lighten-2' : 'white']"
          >
            <v-icon medium>
              mdi-magnify
            </v-icon>
            <span>
              Axtarış
            </span>
          </v-btn>
          <v-btn
            class="mr-2"
            color="primary"
            depressed
            @click="toggleBuyDialog"
            :disabled="!canCreate"
          >
            <v-icon medium>
              mdi-plus
            </v-icon>
            <span>
              Yeni satınalma
            </span>
          </v-btn>
          <v-btn
            class="mr-2"
            color="primary"
            depressed
            @click="toggleSaleDialog"
            :disabled="!canCreate"
          >
            <v-icon medium>
              mdi-plus
            </v-icon>
            <span>
              Yeni satış
            </span>
          </v-btn>

          <v-btn
            class="mr-2"
            color="primary"
            depressed
            @click="toggleDialog"
            :disabled="!canRefund"
          >
            <v-icon medium>
              mdi-cash-refund
            </v-icon>
            <span>
              Yeni geri qaytarılma
            </span>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    showFiltersPanel: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showFilter: false,
    };
  },
  watch: {
    showFiltersPanel: {
      handler() {
        this.showFilter = this.showFiltersPanel;
      },
      immediate: true,
    },
  },
  methods: {
    toggleFiltersPanel() {
      this.showFilter = !this.showFilter;
      this.$emit("showFiltersPanelChanged", this.showFilter);
    },
    toggleBuyDialog() {
      this.$emit("toggleBuyDialog");
    },
    toggleSaleDialog() {
      this.$emit("toggleSaleDialog");
    },
    toggleDialog() {
      this.$emit("toggleDialog");
    },
  },
  computed: {
    canCreate() {
      return this.$store.getters.inRole("ProductOrder:add");
    },
    canRefund() {
      return this.$store.getters.inRole("ProductOrder:refund");
    },
  },
};
</script>
